// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg1 {
  background-color: #171727;
}

.img {
  width: 180px;
}

.qrimg {
  width: 100px;
}

.health {
  width: 600px;
}

.text1 {
  color: #b7b7b7;
  font-size: 1.5vw;
}

.text2 {
  color: #b7b7b7;
  font-size: 1.2vw;
}

.fot {
  color: #b7b7b7;
  font-size: 1vw;
}

.text1 :hover {
  color: #7de01f;
}

.toll {
  font-size: 1.2vw;
  color: #b7b7b7;

}

.scan {
  font-size: 1vw;
  color: #b7b7b7;
}

.icons img {
  width: 25px;
}

.last {
  background-color: black;
  font-size: 1vw;
}
.insta{
  font-size: 21px;
}
.navitems {
  text-decoration: none;
  color: #b7b7b7;
}
.navitems:hover{
  color: #7de01f;
}
.footer_weblink{
 
  text-decoration: none;

}
.footer_weblink:hover{
  color: #7de01f;

}

@media only screen and (max-width: 768px) {
  .text1 {
    font-size: 2.9vw;
  }
  .text2 {
    font-size: 2.8vw;
  }
  .fot {
    font-size: 15px;
  }
  .toll {
    font-size: 20px;
  }
  .scan {
    font-size: 3vw;
  }
  .qrimg {
    width: 60px;
  }
  .icons img {
    width: 18px;
  }
  .icons2 img {
    width: 25px;
  }
  .last {
    font-size: 2.8vw;
  }
  .insta{
    font-size: 19px;
  }
  .navitems_mobile {
    text-decoration: none;
    color: #b7b7b7;
    font-size: 20px;
    line-height: 26px;
  }
  .navitems_mobile:hover{
    color: #7de01f;
  }
  .footer_address{
    font-size: 17px;
  }
  .health_img{
    width: 350px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/Footer/footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;;AAEvB;AACA;EACE,cAAc;;AAEhB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".bg1 {\n  background-color: #171727;\n}\n\n.img {\n  width: 180px;\n}\n\n.qrimg {\n  width: 100px;\n}\n\n.health {\n  width: 600px;\n}\n\n.text1 {\n  color: #b7b7b7;\n  font-size: 1.5vw;\n}\n\n.text2 {\n  color: #b7b7b7;\n  font-size: 1.2vw;\n}\n\n.fot {\n  color: #b7b7b7;\n  font-size: 1vw;\n}\n\n.text1 :hover {\n  color: #7de01f;\n}\n\n.toll {\n  font-size: 1.2vw;\n  color: #b7b7b7;\n\n}\n\n.scan {\n  font-size: 1vw;\n  color: #b7b7b7;\n}\n\n.icons img {\n  width: 25px;\n}\n\n.last {\n  background-color: black;\n  font-size: 1vw;\n}\n.insta{\n  font-size: 21px;\n}\n.navitems {\n  text-decoration: none;\n  color: #b7b7b7;\n}\n.navitems:hover{\n  color: #7de01f;\n}\n.footer_weblink{\n \n  text-decoration: none;\n\n}\n.footer_weblink:hover{\n  color: #7de01f;\n\n}\n\n@media only screen and (max-width: 768px) {\n  .text1 {\n    font-size: 2.9vw;\n  }\n  .text2 {\n    font-size: 2.8vw;\n  }\n  .fot {\n    font-size: 15px;\n  }\n  .toll {\n    font-size: 20px;\n  }\n  .scan {\n    font-size: 3vw;\n  }\n  .qrimg {\n    width: 60px;\n  }\n  .icons img {\n    width: 18px;\n  }\n  .icons2 img {\n    width: 25px;\n  }\n  .last {\n    font-size: 2.8vw;\n  }\n  .insta{\n    font-size: 19px;\n  }\n  .navitems_mobile {\n    text-decoration: none;\n    color: #b7b7b7;\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .navitems_mobile:hover{\n    color: #7de01f;\n  }\n  .footer_address{\n    font-size: 17px;\n  }\n  .health_img{\n    width: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
